import React, {useState} from 'react';
import {Upload} from 'antd';
import {useAxios} from '../Http/AxiosProvider';
import * as Path from 'path';
import {UploadChangeParam, UploadProps} from 'antd/lib/upload';
import {UploadFile} from 'antd/lib/upload/interface';
import {LoadingOutlined, PlusOutlined} from '@ant-design/icons';
import {Config} from '../config';

export default function UploadImage(props: {value: string; onChange: (v: string) => any; label?: string; readOnly?: boolean}) {
  const axios = useAxios();
  const [loading, setLoading] = useState(false);
  const handleChange: UploadProps['onChange'] = (info: UploadChangeParam<UploadFile>) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    console.log(info);
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      setLoading(false);
      props.onChange(info.file.response.path);
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{marginTop: 8}}>{props.label ? props.label : '上传图片'}</div>
    </div>
  );
  return (
    <Upload
      name="file"
      disabled={props.readOnly}
      action={axios.axiosConfig.baseURL + '/Article/UploadImage'}
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      onChange={handleChange}>
      {props.value ? <img src={Config.ossPrefix + '/' + props.value} alt="avatar" style={{width: '100%'}} /> : uploadButton}
    </Upload>
  );
}
